import { render, staticRenderFns } from "./buy-online-ecommerce-btn.vue?vue&type=template&id=503aaa94"
import script from "./buy-online-ecommerce-btn.vue?vue&type=script&lang=js"
export * from "./buy-online-ecommerce-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports